import { useCallback, useLayoutEffect } from 'react';
import { useHistory } from 'hooks/generic/useHistory';
import { useAppSelector } from 'appRedux/hooks';
import { updateQuery } from 'utils/generic/query-route';
import { isEmptyObject } from 'utils/object-methods/is-empty';
import {
  AccountQueryKey,
  EAccountRouteKeys
} from 'constants/account/account-route-keys';
import { IS_KIOSK_GENERIC } from 'constants/app/configs';
import { AccountType } from 'interfaces';

export const useCheckUserForNftCreation = (
  shouldGoToCreatedNfts = false,
  shouldSkipEffectCheck = false
) => {
  const { history } = useHistory();
  const { data: accountCreatorData } = useAppSelector(
    ({ accountCreator }) => accountCreator
  );

  const creatorLoaded = !!accountCreatorData;

  const checkUserForNftCreation = useCallback(() => {
    if (IS_KIOSK_GENERIC) {
      history.push(EAccountRouteKeys.ACCOUNT_PROFILE_MY_NFTS_OWNED);
    }
    if (isEmptyObject(accountCreatorData)) return;
    /*
     * in Default mode there is no type collector, rather it is a user type.
     * However, we are checking reverse logic, not user or collector
     */
    const canCreateNft = [AccountType.Creator, AccountType.Company].includes(
      accountCreatorData?.account_type
    );
    if (!canCreateNft) {
      const nextLocation = updateQuery({
        [AccountQueryKey.modal.value]:
          AccountQueryKey.modal.option.BECOME_CREATOR
      });
      if (shouldGoToCreatedNfts) {
        nextLocation.pathname = EAccountRouteKeys.ACCOUNT_PROFILE_MY_NFTS;
      }
      history.push(nextLocation);
      return false;
    }
    return true;
  }, [accountCreatorData, shouldGoToCreatedNfts]);

  useLayoutEffect(() => {
    if (shouldSkipEffectCheck) {
      return;
    }
    checkUserForNftCreation();
  }, [shouldSkipEffectCheck, checkUserForNftCreation]);

  return { creatorLoaded, checkUserForNftCreation };
};
